import React, { useContext, useEffect } from 'react'
import { StateContext } from 'components/questionnaire/contexts'
import { QuestionDefinition } from 'components/questionnaire/questions.yml'
import clsx from 'clsx'
import './results.scss'

/**
 * Returns a different message when the points are above a certain threshold.
 */
export function results(threshold: number, points: number) {
  // if (points > threshold) {
  //   return 'Ein Testosteron-Check bei ihrem Arzt wäre empfehlenswert.'
  // }

  if (points <= 26) {
    return 'Sie haben keine Beschwerden.'
  }

  if (points >= 27 && points <= 36) {
    return 'Sie haben wenig Beschwerden.'
  }

  if (points >= 37 && points <= 49) {
    return 'Sie haben mittlere Beschwerden. Ein Testosteron-Check bei ihrem Arzt wäre empfehlenswert.'
  }

  if (points >= 50) {
    return 'Sie haben starke Beschwerden. Ein Testosteron-Check bei ihrem Arzt wäre empfehlenswert.'
  }
}

/** Click tracking function for the questionnaire */
function trackQuestionnaireProgress(progress: string) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Interactions',
    event_action: 'click',
    event_label: progress
  })
}

interface Props {
  questions: QuestionDefinition[]
  threshold: number
}

export function Results({ questions, threshold = 37 }: Props) {
  const state = useContext(StateContext)

  useEffect(() => {
    const answeredQuestions = Object.values(state).length

    switch (answeredQuestions) {
      case 1:
        trackQuestionnaireProgress('questionnaire:start')
        break

      case Math.ceil(questions.length / 2):
        trackQuestionnaireProgress('questionnaire:50%')
        break

      case questions.length:
        trackQuestionnaireProgress('questionnaire:complete')
        break
    }
  }, [Object.values(state).length])

  // Only show the results when we have the same amount of answers as we had
  // questions
  const showResults = Object.values(state).length >= questions.length
  let missingAnswer = false

  if (Object.values(state).length < questions.length) {
    missingAnswer = true
  }

  const totalPoints = Object.values<number>(state).reduce(
    (previousValue, currentValue) => previousValue + currentValue,
    0
  )

  const aboveThreshold = totalPoints >= threshold
  return (
    <div>
      {!missingAnswer && (
        <div
          className={clsx(
            'ui large icon message',
            !showResults && 'hidden',
            aboveThreshold ? 'negative' : 'positive'
          )}
        >
          <i className={clsx('icon', 'user md')} />
          <div className='content'>
            <div className='header'>AMS-Resultat: {totalPoints} Punkte</div>
            <p className='resultText'>{results(threshold, totalPoints)}</p>
            <p className='scale'>
              keine Beschwerden: 17-26 Punkte
              <br />
              wenig Beschwerden: 27-36 Punkte
              <br />
              mittlere Beschwerden: 37-49 Punkte
              <br />
              starke Beschwerden: ab 50 Punkte
            </p>
          </div>
        </div>
      )}

      {missingAnswer && (
        <div className={clsx('ui large icon message')}>
          <i className={clsx('icon', 'user md')} />
          <div className='content'>
            <div className='header'>AMS-Resultat:</div>
            <p className='resultText'>
              Sie müssen alle Fragen beantworten, um ein Testresultat zu
              erhalten.
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
